/** @file The outcome under a form or panel: the refusal (translated by code, hint below) and warnings. */
import type { Translate } from '@pose2d/i18n/types';
import { errorText } from '../shell/i18n/errorText';
import type { SubmitResult } from './submitCalls';

/** Renders nothing before the first submit; `showError: false` when a field already shows the error. */
export function FormStatus({ status, t, showError = true }: { status: SubmitResult | null; t: Translate; showError?: boolean }) {
  if (status === null) return null;
  return (
    <div className="p2-form-status" role="status">
      {status.error !== null && showError && <p className="p2-form-error">{errorText(t, { pose2d: status.error })}</p>}
      {status.warnings.map((w, i) => <p key={i} className="p2-form-warning">{w.message}</p>)}
    </div>
  );
}
